import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ForumTopicPostActions extends Component {
  static propTypes = {
    handleReplyClick: PropTypes.func.isRequired,
    handleCiteClick: PropTypes.func.isRequired,
  };

  render() {
    const { handleReplyClick, handleCiteClick } = this.props;
    return (
      <div className="theme__post-actions">
        <button className="button--circle" onClick={handleReplyClick}>
          <img src="/Content/images/btns/msg.svg" />
          <div className="button__hint">Ответить</div>
        </button>
        <button className="button--circle" onClick={handleCiteClick}>
          <img src="/Content/images/btns/blockquote.svg" />
          <div className="button__hint">Цитировать</div>
        </button>
      </div>
    );
  }
}
